/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isFunction } from 'lodash';

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const __vue_script__ = {
    name: 'StringsArrayInput',

    components: { BaseSelect },

    extends: BaseSelect,

    props: {
        value: {
            type: Array,
            default: () => []
        },

        tagTransform: {
            type: Function,
            default: null
        },

        emitEmpty: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            tags: [],
            search: ''
        };
    },

    computed: {
        /**
         * Pass-through listeners
         * @returns {object}
         */
        listeners() {
            // Here we skip the `input` listener, since we provide our own
            // and we don't want it to be overwritten.

            // eslint-disable-next-line
            const { tag, input, ...listeners } = this.$listeners;

            return listeners;
        },

        /**
         * Pass-through attributes
         * @returns {object}
         */
        attrs() {
            /* eslint-disable no-unused-vars */

            // Here we remove all the keys that we don't want `BaseSelect`
            // to inherit from this very component. All other options and attributes
            // are passed through. Basically an underscore.pluck, but since it has been
            // deprecated we are doing it manually.
            const {
                multiple,
                options,
                taggable,
                trackBy,
                emitEmpty,
                tagTransform,
                value,
                ...attrs
            } = Object.assign(this.$options.propsData, this.$attrs);
            /* eslint-enable no-unused-vars */

            return attrs;
        },

        innerValue: {
            /** @returns {object[]} */
            get() {
                if (!this.value) return this.emitEmpty ? [] : undefined;
                return this.value.map(item => ({ label: item, value: item }));
            },

            /** @param {object[]} value */
            set(value) {
                this.$emit('input', value.length ? value.map(d => d.value) : (this.emitEmpty ? [] : undefined));
            }
        }
    },

    methods: {
        /**
         * New tag handler
         *
         * @param {string} tagName
         */
        onNewItem(tagName) {
            if (isFunction(this.tagTransform)) {
                tagName = this.tagTransform(tagName);
            }

            const tag = { label: tagName, value: tagName };
            this.tags.push(tag);
            this.innerValue = [...this.innerValue, tag];
            this.$refs.input.$refs.select.$el.focus();
        },

        /**
         * Store the search value.
         *
         * @param {string} value - The value to store.
         */
        storeSearch(value) {
            this.search = value;
        },

        /**
         * Emulates a blur event on the input element.
         */
        emulateBlur() {
            const allTags = this.tags.map(tag => tag.value);
            const tag = this.search?.trim();
            if (tag?.length && !allTags.includes(tag)) {
                this.onNewItem(tag);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',_vm._g(_vm._b({ref:"input",staticClass:"strings-array-input",attrs:{"multiple":true,"options":_vm.tags,"taggable":true,"track-by":"value","show-no-result":false,"hide-selected":true},on:{"close":_vm.emulateBlur,"search-change":_vm.storeSearch,"tag":_vm.onNewItem},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'base-select',_vm.attrs,false),_vm.listeners))}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "StringsArrayInput.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__